import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private mLoading = false;
  loadingStatus = new Subject<boolean>();

  get loading(): boolean {
    return this.mLoading;
  }

  set loading(value) {
    this.mLoading = value;
    this.loadingStatus.next(value);
  }

  startLoading() {
    this.loading = true;
  }

  stopLoading() {
    this.loading = false;
  }

}
